import { Navigate } from "react-router-dom";
import { useAuth } from "@tellescope/tanstack-query";
import { LoadingScreen } from "../../shared/components/LoadingScreen";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
}

export const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitializing, session } = useAuth();

  if (isInitializing) {
    return <LoadingScreen message="Loading..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  if (session?.userInfo?.requiresMFA) {
    return <Navigate to="/admin/mfa" replace />;
  }

  return <>{children}</>;
};
